import * as PRESCRIPTION from '@/store/constants/prescription'

// Helpers
import {mapActions} from 'vuex'
import moment from 'moment';

// Mixins
import AuthUser from '@/mixins/authenticated-user';

// Components
import PrescriptionDetailsModal from './../PrescriptionModal';
import ListWithSpinner from '@/components/ListWithSpinner';

export default {
  props: {
    patient: {
      type: Object
    }
  },
  data() {
    return {
      fields: [
        'doctor',
        'medicine',
        'dosage',
        'frequency',
        {key: 'duration_start_date', label: 'Start Date', sortable: true},
        {key: 'duration_end_date', label: 'Discontinued Date', sortable: true},
        {key: 'status', sortable: true},
        'action'
      ],
      show_confirmation: false,
      prescriptions: [],
      selected_item: {},
      patient_id: null,
      filter: null,
      selected_id: null,
      action_mode: 'add',
      prescriptions_for_rx: {},
      isProcessing: false
    }
  },

  mixins: [AuthUser],

  components: {
    PrescriptionDetailsModal,
    ListWithSpinner
  },

  methods: {
    ...mapActions({
      getPrescriptions: PRESCRIPTION.ACTION_LIST_PRESCRIPTIONS,
      updatePrescription: PRESCRIPTION.ACTION_UPDATE,
    }),

    handleGetPrescription(id) {
      this.isProcessing = true;
      this.getPrescriptions({
        filter: [`patient_id,=,${id}`]
      }).then((res) => {
        this.isProcessing = false;
        this.prescriptions = res.data;
        this.prescriptions_for_rx = window._.filter(res.data.data, (i) => {
          return i.status === 'active';
        });
      })
    },

    statusVariant(status) {
      return status === 'active' ? 'success' : 'danger'
    },

    refreshData(id) {
      this.handleGetPrescription(id);
    },

    selectItemForEdit(item) {
      this.selected_item = item;
      this.setModalMode('edit');
    },

    handleDiscontinue() {
      this.updatePrescription({
        id: this.selected_id,
        status: 'discontinued',
        duration_end_date: moment().format('YYYY-MM-DD HH:mm:ss')
      }).then(() => {
        this.refreshData(this.patient_id);
      });
    },

    discontinue(id) {
      this.show_confirmation = true;
      this.selected_id = id;
    },

    init() {
      this.patient_id = (this.patient) ? this.patient.id : null;
      this.handleGetPrescription(this.patient_id);
    },

    setModalMode(value) {
      this.action_mode = value;
    }
  },

  mounted() {
    this.init();
  },

  watch: {
    patient(value) {
      if (value.id) {
        this.patient_id = value.id;
        this.handleGetPrescription(value.id);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Prescription/js/prescription-list.js